import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useCan } from '../../hooks/useCan'
import PageLoader from '../PageLoader'

/**
 * Garde des routes du back-office.
 *
 * Deux niveaux : appartenance au personnel pour entrer, puis capacité
 * précise pour la page demandée. Un responsable catalogue qui saisit
 * /admin/analytics est renvoyé vers une page qu'il a le droit de voir,
 * pas vers un écran blanc.
 */
export default function AdminRoute({ children, requires }) {
  const { user, isLoading: loading } = useAuth()
  const { can, isStaff }  = useCan()
  const location = useLocation()

  if (loading) {
    return <PageLoader dark />
  }

  if (!user) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />
  }

  if (!isStaff) {
    return <Navigate to="/" replace />
  }

  if (requires && !can(...(Array.isArray(requires) ? requires : [requires]))) {
    return <Navigate to="/admin" replace />
  }

  return children
}
